export const FETCH_LOCATION_NOT_OFF_REQUEST = "FETCH_LOCATION_NOT_OFF_REQUEST";
export const FETCH_LOCATION_NOT_OFF_SUCCESS = "FETCH_LOCATION_NOT_OFF_SUCCESS";
export const FETCH_LOCATION_NOT_OFF_FAILURE = "FETCH_LOCATION_NOT_OFF_FAILURE";